import { render, staticRenderFns } from "./CourseWare.vue?vue&type=template&id=4fb788a8&scoped=true&"
import script from "./CourseWare.vue?vue&type=script&lang=js&"
export * from "./CourseWare.vue?vue&type=script&lang=js&"
import style0 from "./CourseWare.vue?vue&type=style&index=0&id=4fb788a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb788a8",
  null
  
)

export default component.exports